const HOLD_DELAY_MS = 400; // press this long before a hold starts ticking
const HOLD_TICK_MS = 150;

/**
 * The value one step away, snapped to the step's grid. Hours move 0,5 a tap and 1 on a hold;
 * with quarters (yfirvinna) 0,25 and 0,5. When max ends in ,25 or ,75 taps go in quarters
 * through its last hour, so 7,75 is reached by 7 → 7,25 → 7,5 → 7,75.
 */
export function nextHours(value, direction, max, { held = false, min = 0, quarters = false } = {}) {
  const inLastHour = max % 0.5 !== 0 && (direction > 0 ? value >= Math.floor(max) : value > Math.floor(max));
  let size = held ? 1 : inLastHour ? 0.25 : 0.5;
  if (quarters) size = held ? 0.5 : 0.25;
  const next = (direction > 0 ? Math.floor(value / size) + 1 : Math.ceil(value / size) - 1) * size;
  return Math.max(min, Math.min(next, max));
}

/**
 * Press-and-hold for stepper buttons. button(move) gives the listeners to v-bind on a button;
 * move(held) makes one step and returns whether the value moved. A tap is a click, so a scroll
 * that starts on the button changes nothing. Call stop() in beforeUnmount.
 */
export function createHoldStepper() {
  let timer = null;
  let ticked = false; // a hold moved the value, so the click that ends it is not a tap
  const stop = () => clearTimeout(timer);
  const start = move => {
    stop();
    ticked = false;
    const tick = () => {
      ticked = true;
      // A button disabled at its limit gets no pointerup, so the hold ends itself there
      if (move(true)) timer = setTimeout(tick, HOLD_TICK_MS);
    };
    timer = setTimeout(tick, HOLD_DELAY_MS);
  };
  return {
    stop,
    button: move => ({
      onClick: () => {
        if (!ticked) move(false);
        ticked = false;
      },
      onPointerdown: e => { if (e.button === 0) start(move); },
      onPointerup: stop,
      onPointerleave: stop,
      onPointercancel: stop,
      onContextmenu: e => e.preventDefault(), // long press on touch screens
    }),
  };
}
